function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "5F1F8B47-4296-4E6A-9910-312909BAF03F");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Styleguide-+-UI-Components",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Styleguide",
  transform: "translate(-812.000000, -6320.000000)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon_Cancel",
  transform: "translate(812.000000, 6320.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12,2 C17.5228475,2 22,6.4771525 22,12 C22,17.5228475 17.5228475,22 12,22 C6.4771525,22 2,17.5228475 2,12 C2,6.4771525 6.4771525,2 12,2 Z M12,4 C7.581722,4 4,7.581722 4,12 C4,16.418278 7.581722,20 12,20 C16.418278,20 20,16.418278 20,12 C20,7.581722 16.418278,4 12,4 Z M15.6602788,8.13929784 L15.6631522,8.14217131 L15.8750996,8.35606549 C16.0467547,8.5292973 16.0467547,8.80849301 15.8750996,8.98172481 L12.884,12 L15.8750996,15.0187226 C16.0252978,15.1703004 16.0440726,15.4030068 15.9314239,15.5748668 L15.8750996,15.6443819 L15.6631522,15.8582761 C15.5080747,16.011965 15.2732403,16.0301912 15.1012116,15.9155401 L15.031746,15.8582761 L12.000611,12.7987921 L8.96825402,15.8582761 L8.89878835,15.9155401 C8.75133524,16.0138124 8.55773911,16.0144607 8.407777,15.9158567 L8.33684775,15.8582761 L8.1249004,15.6443819 L8.06857608,15.5748668 C7.97202009,15.4275583 7.97202009,15.2355462 8.06857608,15.0882376 L8.1249004,15.0187226 L11.116,12 L8.1249004,8.98172481 C7.9747022,8.83014698 7.95592743,8.59744054 8.06857608,8.42558055 L8.1249004,8.35606549 L8.33684775,8.14217131 C8.49192531,7.98848236 8.72675973,7.97025621 8.89878835,8.08490732 L8.96825402,8.14217131 L12.000611,11.2016553 L15.031746,8.14217131 C15.204517,7.96781329 15.4859208,7.96652679 15.6602788,8.13929784 Z",
  id: "Combined-Shape"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  opacity: 0,
  x: 0,
  y: 0,
  width: 24,
  height: 24
}))));

var SvgIconCancel = function SvgIconCancel(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconCancel, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Icon_Cancel.5dd71950.svg";
export { ForwardRef as ReactComponent };